import { ImPhone } from "react-icons/im";


interface Props {
    callerNumber: string | null
}
export function VoiceCallBarCallEndedView(props: Props) {
    const { callerNumber } = props;

    return <><div className="flex items-center gap-2">
        <ImPhone className="text-amber-450 size-4 mr-2 animate-slightRotate" />
        <span className="font-semibold text-sm">{callerNumber || "Unknown"}</span>
        <span className="text-xs text-grey-500">Call Ended</span>
    </div>
        <div className="flex items-center gap-2">
        </div>
    </>
}